import { CustomerMenuItemUI } from '@next-order/next-order-components';
import { eventNames } from 'configuration/eventNames';
import { SOLD_OUT_ITEM_PRICE } from 'helpers/enums';
import React, { useContext } from 'react';
import { MenuContext } from 'contexts/MenuProvider';
import classNames from 'classnames';

const eventName = eventNames.MENU_ITEM_OPENED;

function MenuItem({
  menuItem,
  currency,
  displayType = 'grid',
  onClickItemHandler,
  count,
  style = {},
}) {
  const { highlightedItemId } = useContext(MenuContext);
  const item = {
    bgImgSrc: menuItem.bgImgSrc,
    lazyLoad: menuItem.lazyLoad,
    imgSrc: menuItem.imgSrc,
    price: menuItem.price,
    productName: menuItem.productName,
    showName: menuItem.showName,
    ingredients: menuItem.ingredients,
    itemType: menuItem.itemType,
    item: menuItem.item,
  };
  const isSoldOut = item.price === SOLD_OUT_ITEM_PRICE;
  const opacity = isSoldOut ? 0.5 : 1;
  const price = item.price && item.item.type !== '2' ? item.price : undefined;
  const curr = currency && price && !isSoldOut ? currency : '';
  const productName =
    item?.item?.isNameHidden && displayType !== 'list' ? '' : item?.productName;

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onClickItemHandler(item.itemType, item.item, eventName);
  };

  const isHighlighted = highlightedItemId === item.item._id;

  return (
    <div
      data-menu-item-id={item.item._id}
      className={classNames(
        'relative rounded-xl transition-all duration-300',
        {
          'scale-105 z-10 ring-4 ring-primary ring-offset-8 shadow-2xl shadow-primary/40': isHighlighted,
          'scale-100 z-0': !isHighlighted,
        }
      )}
    >
      <CustomerMenuItemUI
        title={productName}
        desc={item.ingredients}
        currency={price?.includes(' ') ? '' : curr}
        price={price}
        displayType={displayType}
        imgSrc={item.bgImgSrc}
        onClick={onClick}
        count={count}
        style={{
          pointerEvents: isSoldOut ? 'none' : 'initial',
          opacity,
          wordBreak: 'break-word',
          ...style,
        }}
      />
    </div>
  );
}

export default MenuItem;
